import { ContentType } from "@seneca/course-service-types";

export default function enrichSectionTextWithContentTypeTag({
  text,
  short,
  contentType
}: {
  text: string;
  short?: boolean;
  contentType: ContentType | undefined | null;
}) {
  if (contentType === ContentType.hardestQuestions) {
    if (short) return text + " HQ";

    return text + " - Hardest Questions";
  }

  return text;
}
